import { useMutation, useQuery, useQueryClient } from "react-query";
import { useMatch } from "react-router-dom";

import {
    deleteBulkManuscript,
    deletePaperSearchHistory,
    getManuscriptList,
    getManuscriptTemplateList,
    getPaperRecommendation,
    getPaperSearch,
    getPaperSearchHistory,
    patchManuscript,
    postManuscript,
} from "utils/request/paper";

const useCurrentSpaceUuid = () => {
    const match = useMatch("/:space_uuid/*");
    return match?.params?.space_uuid ?? "";
};

export const usePaperSearch = (params) => {
    const space_uuid = useCurrentSpaceUuid();
    return useQuery(["paperSearch", space_uuid, params], () => getPaperSearch(space_uuid, params), {
        staleTime: Infinity,
        cacheTime: Infinity,
        retry: false,
        keepPreviousData: true,
    });
};

export const usePaperRecommendation = (params) => {
    const space_uuid = useCurrentSpaceUuid();
    return useQuery(["paperRecommendation", space_uuid, params], (e) => getPaperRecommendation(space_uuid, params), {
        staleTime: Infinity,
        cacheTime: Infinity,
        retry: false,
    });
};

export const usePaperSearchHistory = (params) => {
    const space_uuid = useCurrentSpaceUuid();
    return useQuery(["paperSearchHistory", space_uuid, params], (e) => getPaperSearchHistory(space_uuid, params), {
        staleTime: Infinity,
        cacheTime: Infinity,
        retry: false,
    });
};

export const useDeletePaperSearchHistory = () => {
    const space_uuid = useCurrentSpaceUuid();
    return useMutation((body) => deletePaperSearchHistory(space_uuid, body));
};

export const useManuscripts = (params) => {
    const space_uuid = useCurrentSpaceUuid();
    return useQuery(["manuscripts", space_uuid, params], () => getManuscriptList(space_uuid, params), {
        staleTime: Infinity,
        cacheTime: Infinity,
        retry: false,
        keepPreviousData: true,
    });
};

export const useManuscriptTemplates = (params) => {
    const space_uuid = useCurrentSpaceUuid();
    return useQuery(["manuscriptTemplates", space_uuid, params], () => getManuscriptTemplateList(space_uuid, params), {
        staleTime: Infinity,
        cacheTime: Infinity,
        retry: false,
    });
};

export const useManuscriptCreate = () => {
    const queryClient = useQueryClient();
    const space_uuid = useCurrentSpaceUuid();

    return useMutation((variables) => postManuscript(space_uuid, variables), {
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: "manuscripts" });
        },
    });
};

export const useManuscriptUpdate = () => {
    const queryClient = useQueryClient();
    const space_uuid = useCurrentSpaceUuid();

    return useMutation((variables) => patchManuscript(space_uuid, variables), {
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: "manuscripts" });
        },
    });
};

export const useManuscriptBulkDelete = () => {
    const queryClient = useQueryClient();
    const space_uuid = useCurrentSpaceUuid();

    return useMutation((variables) => deleteBulkManuscript(space_uuid, variables), {
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: "manuscripts" });
        },
    });
};
